/**
 * Builds a composite key for a component using a typical unique identifier,
 * suffixed with a list of values that may change and would require the
 * component to re-render.
 * @param keyId The unique identifier for the component.
 * @param values The values that may change and would cause the component to re-render.
 */
export default function buildCompositeKey(keyId: string, ...values: (string | number | boolean)[]) {
    return `${keyId}::${values.join("::")}`;
}
